import React from 'react';
import commingsoon from '../Assets/comingsoon.jpg';

const ComingSoon = () => {
  return (
    <div className="flex items-center justify-center min-h-screen  px-4">
      <div className="p-8 max-w-2xl text-center">
        {/* Image */}
        <img
          src={commingsoon}
          alt="Hotel Lobby"
          className="w-full h-full object-cover rounded-lg mb-2"
        />

        {/* Message */}
        <h2 className="text-2xl font-bold text-gray-800 mb-2">Coming Soon..!</h2>
        <p className="text-gray-600 font-semibold">
          Exciting Enhancements Coming Your Way! A sleek new feature is arriving soon, designed just
          for your comfort and convenience.
        </p>
      </div>
    </div>
  );
};

export default ComingSoon;
